<template>
  <div class="pagination-tool" align="left" v-if="showPaging">
    <div class="row">
      <div class="col-lg-8">
        <Page v-if="showPaging" show-elevator show-sizer
              :current="page"
              :total="total"
              :page-size="limit"
              :page-size-opts="tablePaginationSize"
              @on-change="handlerCurrentPage"
              @on-page-size-change="handlerPageSize"
              size="small"
              placement="top">
        </Page>
      </div>
    </div>

  </div>
</template>

<script>
    // import * as utils from '../../util'
    export default {
      name: "PageHelper",
      props: {
        showPagingTool: {
          type: Boolean,
          default: true
        },
        newsType: {
          type: Number,
          default: 1
        }
      },
      data () {
        return {
          params: {},
          total: 0,
          page: 1,
          limit: 5,
          tablePaginationSize:[5,10],
        }
      },
      computed:{
        // showTotal() {
        //   const tem = this.$t('global.table.showTotal')
        //   return utils.stringFormat(tem,this.limit * this.page,this.total)
        // },
        showPaging () {
          return this.showPagingTool
        },
      },
      methods:{
        handlerCurrentPage (page) {  //下一页,跳转页查询
          this.page = page
          this.loadData()
        },
        handlerPageSize (limit) { //切换每页大小
          this.page = 1
          this.limit = limit
          this.loadData()
        },
        loadData () {   //数据加载方法
          if (this.showPaging) {
            this.params.page = this.page
            this.params.limit = this.limit
          }
          this.params.language = this.$i18n.locale
          if (this.params) {
            this.$store.dispatch('getNewsList', this.params).then((res)=> {
              if (res && res.result && !res.hasBusinessException) {
                if (this.showPaging) {
                  this.total = res.result[this.newsType].total
                }
              }
            })
          }
        }
      }
    }
</script>




// WEBPACK FOOTER //
// PageHelper.vue?6859ca1c